import type { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  userRouteGuardEnabled: true,
  localPreviewAuthBypass: false,
  cognitoAuthUrl: 'https://europe-north1-saadospankki-dev.cloudfunctions.net/cognitoAuth',
  firebaseAuthEmulatorUrl: null,
  rakennustietoUrl: 'https://oma-qa.rakennustieto.fi/',
  rakennustietoAccountUrl: 'https://oma-qa.rakennustieto.fi/',
  purchaseAccessUrl: 'https://www.rakennustieto.fi/fi/palvelut/rakentajan-lakitutka',
  firebase: {
    apiKey: 'AIzaSyChEcwtdcj-180Tn3aIki2_ISX_UW3BZMA',
    authDomain: 'saadospankki-dev.firebaseapp.com',
    projectId: 'saadospankki-dev',
    storageBucket: 'saadospankki-dev.firebasestorage.app',
    messagingSenderId: '704071661102',
    appId: '1:704071661102:web:16f622ebb64a4afead51bf',
    measurementId: 'G-LFE141D8K9',
  },
};
